import { render, staticRenderFns } from "./ActionPrimerIngresoABodega.vue?vue&type=template&id=4933a6bc&lang=pug"
import script from "./ActionPrimerIngresoABodega.vue?vue&type=script&lang=js"
export * from "./ActionPrimerIngresoABodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports